import DbConfig from '../../../config/DbConfig.js'
import {getLoginId} from '../../functions/Common.js'
import {rtrim,getLocalConfig} from '../../functions/Common.js'

// 获取本地客服列表
export function getCustomList(callback){
	let db = DbConfig.connect()
	let im_open_organization = getLocalConfig('im_open_organization')
	let sql = 'select * from yswl_custom where manager_id = '+getLoginId() + ' order by is_online desc,identity asc'
	if(im_open_organization == 1){
		sql = 'select * from yswl_custom order by is_online desc,identity asc'
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 根据id，获取客服信息
export function getCustomById(id,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('select * from yswl_custom where id = '+id,[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据wxid，获取客服信息
export function getCustomByWxid(wxid,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('select * from yswl_custom where open_id = ?',[wxid],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 获取客服对应的粉丝总数
export function getCustomFansCount(customIds,callback){
	let db = DbConfig.connect()
	let sql = 'select custom_id,count(*) as fans_total from yswl_custom_friends where custom_id in ('+customIds.join(',')+') group by custom_id'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 获取客服对应的群总数
export function getCustomClusterCount(c_open_id,callback){
	let list = []
	if(c_open_id.length == 0){
		callback(list)
		return
	}
	let openIds = ""
	for (var i = 0; i < c_open_id.length; i++) {
		openIds += '"'+c_open_id[i] + '",'
	}
	openIds = rtrim(openIds,",")
	let db = DbConfig.connect()
	let sql = 'select cm.open_id,count(*) as cluster_total from yswl_cluster as c inner join yswl_cluster_member as cm on cm.cluster_id=c.id where cm.open_id in ('+openIds+') group by cm.open_id'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 获取客服对应的消息总数-不包括群消息
export function getCustomMsgCount(customIds,callback){
	let db = DbConfig.connect()
	let sql = 'select custom_id,count(*) as msg_total from yswl_chat_record where custom_id in ('+customIds.join(',')+') group by custom_id'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 更新本地客服在线状态
export function updateCustomOnline(phoneId,val,callback){
	let db = DbConfig.connect()
	let sql = 'update yswl_custom set is_online = ? where phone_id = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[val,phoneId],(tx,results)=>{ 
			callback(true)
		},(error,tx)=>{
			callback(false)
		})
	})
}